<!--
 * @Author: liukai
 * @since: 2022-04-13 17:01:02
 * @LastAuthor: liukai
 * @lastTime: 2022-10-24 19:13:35
-->
<template>
  <div class="home">
    <!-- <Nav title="河南省新冠肺炎实时动态"></Nav> -->
    <refreshList v-model:freshMap="freshMap" @refresh="onRefresh" @onLoad="onLoad">
      <div class="focus_pic" @click="handlePage">
        <img :src="banner" alt="">
      </div>
      <div class="header_nav">
        <div class="item_nav" @click="handleCountry">
          <img :src="pic_country" alt />
          <p class="title">国内疫情</p>
        </div>
        <div class="item_nav" @click="handleHenan">
          <img :src="pic_henan" alt />
          <p class="title">河南疫情</p>
        </div>
        <div class="item_nav" @click="handleGao">
          <img :src="pic_gaomap" alt />
          <p class="title">疫情地图</p>
        </div>
        <div class="item_nav" @click="handleSearch">
          <img :src="pic_search" alt />
          <p class="title">出行查询</p>
        </div>
        <div class="item_nav" @click="handleDanger">
          <img :src="pic_area" alt />
          <p class="title">风险地区</p>
        </div>
      </div>
      <div class="total_pain">
        <h3 @click="handleHenan">
          <span>河南疫情</span>
          <span class="more" @click="handleHenan">
            <span>实时报道</span>
            <img :src="pic_more" alt />
          </span>
        </h3>
        <div class="pain_list" @click="handleHenan">
          <div class="cell">
            <h5>{{  `${henan.addLocalConfirm  >  0  ?  "+"  :  ''}${henan.addLocalConfirm}`  }}</h5>
            <p>昨日新增</p>
          </div>
          <div class="cell">
            <h5 class="red">{{  henan.aggregateConfirm  }}</h5>
            <p>累计确诊</p>
          </div>
          <div class="cell">
            <h5 class="green">{{  henan.aggregateCure  }}</h5>
            <p>累计治愈</p>
          </div>
          <div class="cell">
            <h5 class="death">{{  henan.aggregateDie  }}</h5>
            <p>累计死亡</p>
          </div>
        </div>
        <h3 class="hasmargin" @click="handleCountry">
          <span>国内疫情</span>
          <span class="more" @click="handleCountry">
            <span>实时报道</span>
            <img :src="pic_more" alt />
          </span>
        </h3>
        <div class="country_list" @click="handleCountry">
          <div class="cell">
            <h5>新增本土确诊</h5>
            <p>{{  nationwide.addLocalConfirm  }}</p>
            <h4>
              累计
              <span class="num">{{  nationwide.existingLocalConfirm  }}</span>
            </h4>
          </div>
          <div class="cell">
            <h5>新增无症状</h5>
            <p class="perple">{{  nationwide.addAsymptomatic  }}</p>
            <h4>
              累计
              <span class="num perple">{{  nationwide.existingAsymptomatic  }}</span>
            </h4>
          </div>
          <div class="cell">
            <h5>新增境外输入</h5>
            <p class="red">{{  nationwide.addOverseas  }}</p>
            <h4>
              累计
              <span class="num red">{{  nationwide.aggregateOverseas  }}</span>
            </h4>
          </div>
          <div class="cell">
            <h5>新增确诊</h5>
            <p class="orange">{{  nationwide.addConfirm  }}</p>
            <h4>
              累计
              <span class="num orange">{{  nationwide.aggregateConfirm  }}</span>
            </h4>
          </div>
        </div>
      </div>
      <div class="group">
        <h3>省内专题</h3>
        <div :class="['card']" :style="calculater(henanArtivle[0]?.coverImagesList[1]?.url)">
          <div class="title">
            <span>专题</span>
            <p>{{  henanArtivle[0]?.title  }}</p>
            <span @click="handleZhuanti(henanArtivle[0].id)">查看更多</span>
            <img :src="pic_more1" alt />
          </div>
          <div class="viewer">
            <div class="slider">
              <template v-for="item in henanZhuan" :key="item">
                <div class="cell" @click="handView(item.id)">
                  <div class="pic">
                    <van-image
                      width="37.3333vw"
                      height="20.8vw"
                      fit="cover"
                      position="center"
                      :src="item.coverImagesList[0].url"
                    />
                  </div>
                  <p>{{  item.title  }}</p>
                </div>
              </template>
              <div class="lastBar">&nbsp;&nbsp;</div>
            </div>
          </div>
        </div>
      </div>
      <div class="group">
        <h3>国内专题</h3>
        <div class="card" :style="calculater(countryArticle[0]?.coverImagesList[1]?.url)">
          <div class="title">
            <span>专题</span>
            <p>{{  countryArticle[0]?.title  }}</p>
            <span @click="handleZhuanti(countryArticle[0].id)">查看更多</span>
            <img :src="pic_more1" alt />
          </div>
          <div class="viewer">
            <div class="slider">
              <template v-for="item in countryZhuan" :key="item">
                <div class="cell" @click="handView(item.id)">
                  <div class="pic">
                    <van-image
                      width="37.3333vw"
                      height="20.8vw"
                      fit="cover"
                      position="center"
                      :src="item.coverImagesList[0].url"
                    />
                  </div>
                  <p>{{  item.title  }}</p>
                </div>
              </template>
              <div class="lastBar">&nbsp;&nbsp;</div>
            </div>
          </div>
        </div>
      </div>

      <div class="news_list">
        <h3>最新消息</h3>

        <template v-for="item in streamArticle" :key="item.id">
          <newsCard :item="item"></newsCard>
        </template>
      </div>
    </refreshList>
  </div>
</template>

<script>
import Nav from "@/components/nav-bar.vue";
import { reactive, onMounted, toRefs, onBeforeMount } from "vue";
import { Divider, Col, Row, Image as VanImage } from "vant";
import HenanMap from "@/components/map.vue";
import Broken from "@/components/broken.vue";
import newsCard from "@/components/newsCard.vue";
import { getoverview, getArticle, getArticleZhuan } from "@/api";
import { useRouter } from "vue-router";
import { openPage } from "@/utils/appMethods";
import { openArticle, openZhuanti } from "@/utils/appMethods.js";
import refreshList from "@/components/refreshList.vue";
import checkDevice from "@/utils/tools";
import yiqiTrack from "@/utils/track.js";
export default {
  name: "henan",
  components: {
    Nav,
    HenanMap,
    Broken,
    newsCard,
    [Divider.name]: Divider,
    [Col.name]: Col,
    [Row.name]: Row,
    [VanImage.name]: VanImage,
    refreshList,
  },
  setup () {
    const data = reactive({
      banner:`https://static.hntv.tv/total/lk/images/banner.jpg?t=${new Date().getTime()}`,
      pic_more: require("@/assets/img/pic_more.png"),
      pic_more1: require("@/assets/img/pic_more1.png"),
      pic_country: require("@/assets/img/pic_country.png"),
      pic_henan: require("@/assets/img/pic_henan.png"),
      pic_area: require("@/assets/img/pic_area.png"),
      pic_search: require("@/assets/img/pic_search.png"),
      pic_gaomap: require("@/assets/img/gaomap.png"),
      henan: {
        addAsymptomatic: 0,
        addLocalConfirm: 0,
        aggregateConfirm: 0,
        aggregateCure: 0,
        aggregateDie: 0,
        date: 0,
        id: 0,
        provinceName: 0,
        statisticsTime: 0,
        updateTime: 0,
      },
      nationwide: {
        addAsymptomatic: 0,
        addConfirm: 0,
        addLocalConfirm: 0,
        addOverseas: 0,
        aggregateConfirm: 0,
        aggregateConfirmAdd: 0,
        aggregateCure: 0,
        aggregateCureAdd: 0,
        aggregateDie: 0,
        aggregateDieAdd: 0,
        aggregateOverseas: 0,
        aggregateOverseasAdd: 0,
        existingAsymptomatic: 0,
        existingConfirm: 0,
        existingLocalConfirm: 0,
        existingOverseas: 0,
        id: 0,
        statisticsTime: 0,
        updateTime: 0,
      },
      pageNo: 1,
      pageSize: 6,
      testChanel: "1420287272183422977",
      henanArtivle: [],
      countryArticle: [],
      streamArticle: [],
      henanZhuan: [],
      countryZhuan: [],
      freshMap: {
        refreshLoad: false,
        listLoading: false,
        listFinished: false,
      },
    });
    const router = useRouter();
    const methodsMap = {
      calculater: (img) => {
        let res = {
          backgroundImage: `linear-gradient(to top,#fff 53%,rgba(255, 255, 255, 0) 83%),url("${img}")`,
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
        };
        return res;
      },
      requestOverview: () => {
        getoverview().then((res) => {
          if (res.data.code == 0) {
            data.henan = res.data.data.henan;
            data.nationwide = res.data.data.nationwide;
          }
        });
      },
      requestHenanArticle: () => {
        let param = {
          pageNo: 1,
          pageSize: 6,
          channelId: "1516948032031748097",
          // channelId: data.testChanel,
        };
        getArticle(param).then((res) => {
          console.log(res);
          if (res.data.code == 0) {
            data.henanArtivle = res.data.result.content;
            methodsMap.getZhuan(data.henanArtivle[0].id).then((res) => {
              data.henanZhuan = res;
            });
          }
        });
      },
      requestCountryArticle: () => {
        let param = {
          pageNo: 1,
          pageSize: 6,
          channelId: "1516948089601196033",
          // channelId: data.testChanel,
        };
        getArticle(param).then((res) => {
          console.log(res);
          if (res.data.code == 0) {
            data.countryArticle = res.data.result.content;
            methodsMap.getZhuan(data.countryArticle[0].id).then((res) => {
              data.countryZhuan = res;
            });
          }
        });
      },
      requestStreamArticle: (onLoad) => {
        let param = {
          pageNo: data.pageNo,
          pageSize: data.pageSize,
          channelId: "1516947929504612353",
          // channelId: data.testChanel,
        };
        return new Promise((resolve, reject) => {
          getArticle(param)
            .then((res) => {
              console.log(res);
              if (res.data.code == 0) {
                data.freshMap.listLoading = false;
                data.freshMap.listFinished = res.listFinished;
                data.streamArticle = onLoad
                  ? data.streamArticle.concat(res.data.result.content)
                  : res.data.result.content;
                console.log(data.streamArticle, "dataaa");
                if (data.pageNo >= res.data.result.totalPage) {
                  data.freshMap.listFinished = true;
                } else {
                  data.pageNo = res.data.result.pageNo + 1;
                }
              }
              resolve(res);
            })
            .catch((err) => {
              reject(err);
            });
        });
      },

      handleHenan: () => {
        yiqiTrack("yq_hnyq");
        window.dx.isDxApp().then((res) => {
          if (!res) {
            router.push({
              path: "henan",
            });
          } else {
            openPage(`${location.href}henan`);
          }
        });
      },
      handleCountry: () => {
        yiqiTrack("yq_gnyq");

        window.dx.isDxApp().then((res) => {
          if (!res) {
            router.push({
              path: "country",
            });
          } else {
            openPage(`${location.href}country`);
          }
        });
      },
      handleSearch: () => {
        yiqiTrack("yq_cxcx");

        window.dx.isDxApp().then((res) => {
          if (!res) {
            router.push({
              path: "search",
            });
          } else {
            openPage(`${location.href}search`);
          }
        });
      },
      handleDanger: () => {
        yiqiTrack("yq_fxdq");

        window.dx.isDxApp().then((res) => {
          if (!res) {
            location.href =
              "http://bmfw.www.gov.cn/myqfxdjcx/index.html?aman=6l9b0a629Af0ff2b9X0e7";
          } else {
            openPage(
              `http://bmfw.www.gov.cn/myqfxdjcx/index.html?aman=6l9b0a629Af0ff2b9X0e7`
            );
          }
        });
      },
      handlePage: () => {
        yiqiTrack("yq_hztd");
        window.dx.isDxApp().then((res) => {
          if (!res) {
            location.href = "http://static.hntv.tv/total/ch/dxwz/index.html#/";
          } else {
            openPage(`http://static.hntv.tv/total/ch/dxwz/index.html#/`);
          }
        });
      },
      handleGao: () => {
        yiqiTrack("yq_yqdt");
        window.dx.isDxApp().then((res) => {
          if (!res) {
            location.href = "https://cache.amap.com/activity/partner/plague-map/index.html?isjump=false&fromchannel=elephant&awaken_type=bottom&gd_from=yq_daxiang&poi_btn=1";
          } else {
            openPage(`https://cache.amap.com/activity/partner/plague-map/index.html?isjump=false&fromchannel=elephant&awaken_type=bottom&gd_from=yq_daxiang&poi_btn=1`);
          }
        });
      },
      handleZhuanti: (id) => {
        openZhuanti(id);
      },
      getZhuan (id) {
        // let id = "1452832948898357250";
        return new Promise((resolve, reject) => {
          getArticleZhuan(id)
            .then((res) => {
              let reslut;
              if (res.data.code == 0) {
                console.log(res.data.result.specialDTO.list, "============");

                if (
                  res.data.result.specialDTO.list[0].articleDTOList.length > 5
                ) {
                  reslut =
                    res.data.result.specialDTO.list[0].articleDTOList.splice(
                      0,
                      6
                    );
                } else {
                  reslut = res.data.result.specialDTO.list[0].articleDTOList;
                }
              }
              resolve(reslut);
            })
            .catch((err) => {
              reject(err);
            });
        });
      },
      handView (id) {
        openArticle(id);
      },
      //下拉刷新
      onRefresh: () => {
        data.freshMap.refreshLoad = true;
        data.pageNo = 1;
        Promise.all([
          //获取文章
          methodsMap.requestHenanArticle(),
          methodsMap.requestCountryArticle(),
          methodsMap.requestStreamArticle(),

          //获取疫情数据
          methodsMap.requestOverview(),
        ]).then(() => {
          data.freshMap.refreshLoad = false;
        });
        data.banner = `https://static.hntv.tv/total/lk/images/banner.jpg?t=${new Date().getTime()}`
      },

      // 触底加载
      onLoad: () => {
        methodsMap.requestStreamArticle(true);
      },

      androidSlide: () => {
        // document
        //   .getElementsByClassName("viewer")[0]
        //   .addEventListener("scroll", function (e) {
        //     let width, height, box, top;
        //     height = document.getElementsByClassName("viewer")[0].offsetHeight;
        //     width = document.getElementsByClassName("viewer")[0].offsetWidth;
        //     top=document.getElementsByClassName("viewer")[0].offsetTop;
        //     box = document
        //       .getElementsByClassName("viewer")[0]
        //       .getBoundingClientRect();
        //     console.log(top);
        //     window.Android.disPatchTouchViewPager(
        //       box.left,
        //       top,
        //       width,
        //       height
        //     );
        //   });

        function androidEvent () {
          document
            .getElementsByClassName("viewer")[0]
            .addEventListener("touchstart", function (e) {
              //  window.Android.setWebViewPagerArea(obj);
              //  window.Android.disPatchTouchViewPager(obj);
              getTop_Bottom(0);
            });
          document
            .getElementsByClassName("viewer")[1]
            .addEventListener("touchstart", function (e) {
              getTop_Bottom(1);
              //  window.Android.setWebViewPagerArea(obj);
              //  window.Android.disPatchTouchViewPager(obj);
            });
        }
        function getTop_Bottom (index) {
          let top, height;
          top = document.getElementsByClassName("viewer")[index].offsetTop;
          height =
            document.getElementsByClassName("viewer")[index].offsetHeight;
          window.Android.disPatchTouchViewPager(top, top + height);
        }

        window.dx.isDxApp().then((res) => {
          if (!res) {
            console.log("H5");
          } else {
            let device = checkDevice();
            if (device == "andriod") {
              androidEvent();
            }
          }
        });
      },
    };
    onMounted(() => {
      methodsMap.requestHenanArticle();
      methodsMap.requestCountryArticle();
      methodsMap.requestStreamArticle();

      //安卓滑动
      methodsMap.androidSlide();
    });
    onBeforeMount(() => {
      methodsMap.requestOverview();
    });
    return {
      ...toRefs(data),
      ...methodsMap,
    };
  },
};
</script>

<style lang="scss" >
@import "@/css/wap/mixin.scss";

.home {
  width: 375px;
  background-color: #fff;
  box-sizing: border-box;
  font-family: PingFang SC;
  min-height: 100vh;

  .focus_pic {
    img {
      width: 375px;
      // height: 210px;
    }
  }

  .header_nav {
    width: 345px;
    margin: 16px auto 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 58px;

    .item_nav {
      height: 58px;
      width: 59px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: center;

      img {
        width: 30px;
        height: 30px;
      }

      p {
        color: #444444;
        font-weight: 500;
        font-size: 14px;
        letter-spacing: 6%;
      }
    }
  }

  .total_pain {
    position: relative;
    padding: 15px;

    h3 {
      display: flex;
      justify-content: space-between;
      align-items: center;

      :nth-child(1) {
        color: #444444;
        font-weight: bold;
        font-size: 16px;
      }

      .more {
        display: flex;
        justify-content: flex-start;
        align-items: center;

        span {
          color: #999999;
          font-weight: normal;
          font-size: 13px;
          line-height: 19px;
          vertical-align: bottom;
        }

        img {
          margin-left: 3px;
          width: 18px;
          height: 18px;
        }
      }
    }

    .hasmargin {
      margin-top: 16px;
    }

    .country_list {
      margin-top: 16px;
      display: flex;
      justify-content: space-evenly;
      align-items: center;

      .cell {
        width: 86px;
        height: 53px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: center;
        @include noWrap;
        overflow: hidden;

        h5 {
          color: #444444;
          font-weight: 500;
          font-size: 12px;
        }

        p {
          color: #eda546;
          font-weight: bold;
          font-size: 16px;
          text-align: center;
          width: 86px;
          @include noWrap;
        }

        h4 {
          font-size: 10px;
          color: #444444;
          width: 86px;
          @include noWrap;
          text-align: center;
        }

        .num {
          color: #eda546;
        }

        .perple {
          color: #ac45cd;
        }

        .red {
          color: #d82e2a;
        }

        .death {
          color: #102a4d;
        }

        .orange {
          color: #ec5235;
        }
      }

      .lastBar {
        width: 10px;
        height: 53px;
      }
    }

    .pain_list {
      margin-top: 16px;
      display: flex;
      justify-content: space-evenly;
      align-items: center;

      .cell {
        width: 80.3px;
        height: 64px;
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        align-items: center;
        background-color: #f6f7fd;
        overflow: hidden;

        h5 {
          color: #4a5ec7;
          font-weight: bold;
          font-size: 22px;
          width: 80.3px;
          @include noWrap;
          text-align: center;
        }

        p {
          color: #444444;
          font-weight: 500;
          font-size: 12px;
        }

        .red {
          color: #ce2b1d;
        }

        .brown {
          color: #962928;
        }

        .green {
          color: #4ca284;
        }

        .death {
          color: #051839;
        }
      }

      :nth-child(2) {
        background-color: #faf3f3;
      }

      :nth-child(3) {
        background-color: #f3faf8;
      }

      :nth-child(4) {
        background-color: #f1f2f4;
      }
    }
  }

  .group {
    width: 345px;
    margin: 16px auto;

    h3 {
      font-size: 16px;
      color: #444;
      font-weight: bold;
    }

    .card {
      margin-top: 12px;
      width: 345px;
      height: 153px;
      border-top-left-radius: 8px;
      border-top-right-radius: 8px;
      // background-image: linear-gradient(
      //     to top,
      //     #fff 53%,
      //     rgba(255, 255, 255, 0) 83%
      //   ),
      //   url("https://cdn.jsdelivr.net/npm/@vant/assets/cat.jpeg");
      // background-size: cover;
      // background-repeat: no-repeat;
      // background: linear-gradient(to top,#fff 53%,rgba(255, 255, 255, 0) 83%) url() cover no-repeat;
      padding-top: 16px;

      .title {
        margin: 0 12px;
        display: flex;
        justify-content: space-evenly;
        align-content: center;

        :nth-child(1) {
          display: inline-block;
          background-color: #2c71c1;
          width: 40px;
          height: 21px;
          border-radius: 4px;
          color: #fff;
          font-size: 12px;
          text-align: center;
          line-height: 21px;
        }

        :nth-child(2) {
          width: 198px;
          font-size: 14px;
          @include noWrap;
          color: #fff;
          line-height: 21px;
        }

        :nth-child(3) {
          width: 50px;
          line-height: 21px;
          font-size: 12px;
          color: #fff;
        }

        :nth-child(4) {
          width: 20px;
          height: 20px;
        }
      }
    }

    .viewer {
      margin-top: 16px;
      width: 345px;
      height: 120px;
      overflow: scroll;

      &::-webkit-scrollbar {
        display: none;
      }

      .slider {
        padding-right: 12px;
        display: flex;
        justify-content: flex-start;
        flex-wrap: nowrap;

        // background-color: #fff;
        .cell {
          margin-left: 10px;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          align-items: flex-start;
          // background-color: #fff;

          height: 120px;

          .pic {
            border-radius: 4px;
            overflow: hidden;
            width: 140px;
            height: 78px;
            border-radius: 4px;
            display: flex;
            justify-content: center;
            align-items: center;
          }

          p {
            color: #444;
            font-size: 12px;
            @include noWrapN(2);
            width: 140px;
            line-height: 1.45;
          }
        }
      }
    }
  }

  .news_list {
    width: 345px;
    margin: 0 auto;
    padding-bottom: 30px;

    h3 {
      color: #444444;
      font-weight: bold;
      font-size: 16px;
    }
  }
}
</style>